// RichTextEditor.js
import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import CodeDisplay from './CodeDisplay';
import { ExclamationCircleIcon } from '@heroicons/react/20/solid'

const InputRichText = ( { label, name, err, handleChange, defaultValue, disabled, switchField, switchFieldDefault, enableSwitch, required } ) => {
  const [content, setContent] = useState(defaultValue || '');
  const [editMode, setEditMode] = useState(switchFieldDefault || 'visual');

  const handleContentChange = (value) => {
    setContent(value);
    
    handleChange({ target : {
      name: name,
      value: value,
    }})
  };

  const switchMode = (e) => {
    e.preventDefault();
    setEditMode(editMode === 'visual' ? 'code' : 'visual');
    if(switchField){
      handleChange({ target : {
        name: switchField,
        value: editMode === 'visual' ? 'code' : 'visual',
      }})
    }
    
  };
  const toolbarOptions = [
    //[{ 'font': [] }],
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ 'color': [] }, { 'background': [] }],
    [{ 'script': 'sub' }, { 'script': 'super' }],
    [{ 'align': [] }],
    ['blockquote', 'code-block'],
    [{ 'list': 'ordered' }, { 'list': 'bullet' },
    { 'indent': '-1' }, { 'indent': '+1' }],
    ['link', 'image', 'video'],
    ['clean'],
  ];

  // const quillStyle = {
  //   minHeight: '80px', // Set the minimum height
  // };

  return (
    <div>
      {
        label &&
        <label htmlFor={name} className="block text-sm font-medium leading-6 text-gray-900 text-left">
          {label}{required ? "*" : ""}
        </label>
      }

      <div className="flex flex-col md:flex-row relative">
        <div className={`w-full md:w-full pr-4`}>
          {
            enableSwitch && <div>
              <button onClick={switchMode} className="bg-blue-500 text-white py-2 px-4">
                {editMode === 'visual' ? 'Switch to Code Mode' : 'Switch to Visual Mode'}
              </button>
            </div>
          }
          

          {editMode === 'visual' ? (
            <ReactQuill
              theme="snow"
              value={content}
              onChange={handleContentChange}
              modules={{ toolbar: toolbarOptions }}
              placeholder="Type something..."
              className=''
            />
          ) : (
            <CodeDisplay content={content} onContentChange={handleContentChange} />
          )}
        </div>
        {
          err &&
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-5">
            <ExclamationCircleIcon className="h-5 w-5 text-red-500" aria-hidden="true" />
          </div>
        }
      </div>
      {
        err && <p className="text-left mt-2 text-sm text-red-600">
        { err }
      </p>
      }
      
    </div>
  );
};

export default InputRichText;
